
//フレームの形状
export class ShapeInfo{
    id : number = 0;
    name : string = ""; //shapeの名前 "rect" "roundRect" "ellipse" "8cmCD-R" "CD_DVD"
    cornerDiameter : any = null; //不明
    width : number = 0; //不明
    height : number = 0; //不明
    innerDiameter : number = 0; //角丸み -> 0より大なのはこの値のみなので、この値のみ使う。
    outerDiameter : number = 0; //CDの外側の丸み？(不明)
    frontFxg : any = null; //SVG描画が必要な用紙フォーマットにはfront_fxg、back_fxgにSVGファイルのBase64エンコードデータが入っています
    useFrontFxg : any = null; //不明
    backFxg : any = null; //不明
    useBackFxg : any = null; //不明
    imageFormat : number = 0;   // 画像フォーマット 0:ラベル屋さん9形式, 1:base64, 2:base64(圧縮)
}